import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { asyncScheduler } from 'rxjs';

@Component({
  selector: 'app-range-limits',
  templateUrl: './range-limits.component.html',
  styleUrls: ['./range-limits.component.scss'],
})
export class RangeLimitsComponent implements OnInit, OnChanges {

  @Input() minimum = 0;
  @Input() content = 0;
  @Input() maximum = 0;
  @Input() position = 0;

  public tick = 100;
  public rangeMin = 0;
  public rangeMax = 0;
  public rangeContent = 0;
  public tickCart = 0;
  public positionCart = 0;
  public isIOS = false;

  private isConfetti = false;
  private btnConfetti = document.getElementsByClassName('confetti-button');

  constructor() {
    this.isIOS = Capacitor.getPlatform() === 'ios' && Capacitor.isNativePlatform();
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('position') && changes.position.currentValue === this.position) {
      if (this.content > 0 && this.minimum < 1) {
        this.maximum = (this.content * 15) / 100;
      }
      if (this.content < 1 && this.minimum > 0) {
        this.rangeMax = 0;
        this.rangeContent = this.minimum + (this.minimum / 100 * 15);
        this.tick = 100 / this.rangeContent;
      } else {
        this.tick = 100 / this.content;
        this.rangeContent = this.content;
        this.rangeMax = this.maximum * this.tick < 3 ? 3 : this.maximum * this.tick; // ? Espacio de barra máxima, si es menor a 3%, se escala al 3%
      }

      this.rangeMin = this.minimum > 0 && (this.minimum * this.tick) < 5 ? 15 : this.minimum * this.tick; // ? Espacio de barra minima, si es menor a 5%, se escala al 15%
      this.tickCart = this.minimum > 0 && (this.minimum * this.tick) < 5 ? 15 / this.minimum : this.tick; // ? Progreso de ticks, si es menor a 5%, se escala al 15% hasta cumplir el minimo, despues avanza con el valor real

      const spare = this.rangeMax > 0 ? 0 : ((this.rangeContent - this.minimum) / 2) * -1;
      const positionMax = this.rangeContent + (this.rangeMax > 0 ? this.maximum : spare);
      const positionCurrent = (this.position > positionMax ? positionMax : this.position); // ? Acumulativo de productos vs el contenedor de barras
      this.positionCart = this.minimum > 0 && (this.minimum * this.tick) < 5 && this.position >= this.minimum ?
        15 + (positionCurrent * (85 / (this.rangeContent - this.minimum)))
        : positionCurrent * this.tickCart; // ? Progreso de Knobs, si es menor a 5%, se escala al 15%, pasando el minimo se le suma el 15% * el sobrante de escala y contenido-minimo

      if (this.position >= this.minimum && !this.isConfetti) {
        this.isConfetti = true;
        for (var i = 0; i < this.btnConfetti.length; i++) {
          this.btnConfetti[i].addEventListener('click', this.animateButton, false);
        }
        asyncScheduler.schedule(() => document.getElementById('confetti-button')?.click(), 300);
        document.getElementById('confetti-button')?.dispatchEvent(new Event('mouseover'));
      } else if (this.position < this.minimum && this.isConfetti) {
        this.isConfetti = false;
      }
    }
  }

  private animateButton = (e: any) => {
    e.preventDefault;
    e.target['classList'].remove('animate', 'swiped');
    e.target['classList'].add('animate', 'swiped');
    setTimeout(() => e.target['classList'].remove('animate', 'swiped'), 700);
  };

}
